(function () {
  function copyText(text) {
    if (!text) return Promise.reject();

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    // Fallback for older browsers
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand("copy");
        document.body.removeChild(ta);
        ok ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".mm-promo-card__code-btn");
    if (!btn) return;

    var text = (btn.getAttribute("data-copy-text") || "").trim();
    copyText(text)
      .then(function () {
        btn.classList.add("copied");
        window.setTimeout(function () {
          btn.classList.remove("copied");
        }, 1400);
      })
      .catch(function () {
        // If copy fails, do nothing
      });
  });
})();
(function () {
  function fallbackCopyText(text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve) {
      fallbackCopyText(text);
      resolve();
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".mm-promo-card__code-btn");
    if (!btn) return;

    var text = (btn.getAttribute("data-copy-text") || "").trim();
    if (!text) return;

    copyText(text).then(function () {
      btn.classList.add("copied");
      window.setTimeout(function () {
        btn.classList.remove("copied");
      }, 1400);
    });
  });
})();
